import React, { useEffect, useState } from "react";
import { FormValidate } from "../../../../../components/formValidate";
import CustomButton from "../../../../../components/inputs/button";
import Loader from "../../../../../components/loader/loader";
import Snackbar from "../../../../../components/snackbar/snackbar";
import {
  admin_areatype_add,
  admin_areatype_edit,
} from "../../../admin.api";
import "./dialog.css";
import TextField from "../../../../../components/inputs/textfield";

const Dialog = ({ open, edit, view, handleClose, formData: initialData }) => {
  const [formData, setFormData] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({});
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) handleClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const error = FormValidate(formData);

    if (Object.keys(error).length === 0) {
      setIsActive(true);
      const data = { name: formData.name };

      const submitAction = edit
        ? admin_areatype_edit(formData.id, data)
        : admin_areatype_add(data);

      submitAction
        .then((res) => {
          setSubmitted(true);
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
        })
        .catch((err) => {
          setSubmitted(false);
          setSnackMessage(err.message);
          setIsSnackError(true);
          setSnackOpen(true);
        })
        .finally(() => setIsActive(false));
    } else {
      setSubmitted(false);
      setSnackMessage("Please fill all mandatory fields");
      setIsSnackError(true);
      setSnackOpen(true);
    }
  };

  if (!open) return null;

  return (
    <div className="overlay">
      <Loader open={isActive} />
      <div className="big-dia dialog">
        <Snackbar
          message={snackMessage}
          error={isSnackError}
          open={snackOpen}
          close={snackbarClose}
        />
        <div className="row">
          <div className="flexDisplay">
            <div className="diaTitleCon">
              {edit ? "Edit Area Type" : view ? "Area Type" : "Add Area Type"}
            </div>
            <div className="dia-close" onClick={handleClose}>
              <div className="diaCloseCon">
                <div className="diaClose">&#10005;</div>
              </div>
            </div>
          </div>
          <div className="tilebar d-flex justify-content-start">
            <hr />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="book-form">
              <div className="col-12">
                <TextField
                  label="Area Type"
                  name="name"
                  variant="outlined"
                  disabled={view}
                  type="text"
                  value={formData?.name ?? ""}
                  onChange={handleChange}
                  required
                />
              </div>

              {!view && (
                <div className="col-12">
                  <CustomButton
                    label={edit ? "Update" : "Add"}
                    disabled={submitted}
                    onClick={handleSubmit}
                  />
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
